export default "__VITE_ASSET__fn$UuoSJ__"